import { enCommonTranslations } from './locales/en/common';
import { enAuthTranslations } from './locales/en/auth';
import { enHomePageTranslations } from './locales/en/homePage';
import { enDashboardTranslations } from './locales/en/dashboard';
import { enOrdersTranslations } from './locales/en/order';
import { enCategoriesTranslations } from './locales/en/categories';
import { enSettingsTranslations } from './locales/en/settings';
import { enAnalyticsTranslations } from './locales/en/analytics';
import { enMenuItemsTranslations } from './locales/en/menuItems';
import { enNotificationsTranslations } from './locales/en/notifications';
import { enAgentTranslations } from './locales/en/agent';
import { enInactivePageTranslations } from './locales/en/inactivePage';
import { enDietaryPreferencesTranslations } from './locales/en/dietaryPreferences';
import { enMenuManagementTranslations } from './locales/en/menuManagement';
import { enAnnouncementsTranslations } from './locales/en/announcements';

import { arCommonTranslations } from './locales/ar/common';
import { arAuthTranslations } from './locales/ar/auth';
import { arHomePageTranslations } from './locales/ar/homePage';
import { arDashboardTranslations } from './locales/ar/dashboard';
import { arOrdersTranslations } from './locales/ar/order';
import { arCategoriesTranslations } from './locales/ar/categories';
import { arSettingsTranslations } from './locales/ar/settings';
import { arAnalyticsTranslations } from './locales/ar/analytics';
import { arMenuItemsTranslations } from './locales/ar/menuItems';
import { arNotificationsTranslations } from './locales/ar/notifications';
import { arAgentTranslations } from './locales/ar/agent';
import { arInactivePageTranslations } from './locales/ar/inactivePage';
import { arDietaryPreferencesTranslations } from './locales/ar/dietaryPreferences';
import { arMenuManagementTranslations } from './locales/ar/menuManagement';
import { arFeedback } from './locales/ar/feedback';
import { enFeedback } from './locales/en/feedback';
import { arAnnouncementsTranslations } from './locales/ar/announcements';
export const resources = {
	en: {
		translation: {
			...enCommonTranslations,
			...enAuthTranslations,
			...enHomePageTranslations,
			...enDashboardTranslations,
			...enOrdersTranslations,
			...enCategoriesTranslations,
			...enSettingsTranslations,
			...enAnalyticsTranslations,
			...enMenuItemsTranslations,
			...enNotificationsTranslations,
			...enAgentTranslations,
			...enInactivePageTranslations,
			...enDietaryPreferencesTranslations,
			...enMenuManagementTranslations,
			...enAnnouncementsTranslations,
			...enFeedback,

		}
	},
	ar: {
		translation: {
			...arCommonTranslations,
			...arAuthTranslations,
			...arHomePageTranslations,
			...arDashboardTranslations,
			...arOrdersTranslations,
			...arCategoriesTranslations,
			...arSettingsTranslations,
			...arAnalyticsTranslations,
			...arMenuItemsTranslations,
			...arNotificationsTranslations,
			...arAgentTranslations,
			...arInactivePageTranslations,
			...arDietaryPreferencesTranslations,
			...arMenuManagementTranslations,
			...arAnnouncementsTranslations,
			...arFeedback,
			
		}
	}
};
